import { injectAttributesOf } from '@adornis/chemistry/directives/inject-attributes.js';
import { XInput } from '@adornis/forms/x-input.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { live } from 'lit/directives/live.js';
import { ref } from 'lit/directives/ref.js';

/**
 * @element tr-input
 */
@customElement('tr-input')
// @ts-expect-error private
export class TrInput extends XInput {
  @property() realPlaceholder?: string;

  // @ts-expect-error private override
  private override input() {
    return html`
      <input
        placeholder=${this.realPlaceholder ?? this.getAttribute('placeholder')}
        @focus=${() => (this.focused = true)}
        @input=${(e: Event) => {
          this.processNewValue();
        }}
        @search=${(e: Event) => {
          this.processNewValue();
        }}
        @keydown=${(e: KeyboardEvent) => {
          if (this.type === 'number') {
            // @ts-expect-error private
            const step = this._getNumericAttributeSafe('step') ?? 1;
            if (e.key.length === 1 && !/[0-9.,\-]/.test(e.key)) e.preventDefault();
            if (e.key === 'ArrowUp') {
              e.preventDefault();
              this.processNewValue(+(this.value.value ?? 0) + step + '', 'arrowKey');
            }
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              this.processNewValue(+(this.value.value ?? 0) - step + '', 'arrowKey');
            }
          }
        }}
        @keyup=${(e: KeyboardEvent) => {
          if (e.key === 'Enter')
            return this.dispatchEvent(
              new CustomEvent('submit', {
                detail: { value: this.processNewValue() },
                composed: true,
                bubbles: true,
              }),
            );
          if (e.key === 'Escape') return this.dispatchEvent(new CustomEvent('escape'));
        }}
        @blur=${(e: Event) => {
          this.focused = false;
          this.processNewValue(undefined, 'blur');
          this.dispatchEvent(new CustomEvent('value-picked', { detail: { value: this.value.value } }));
        }}
        @click=${(e: Event) => e.stopPropagation()}
        .value=${live(
          // @ts-expect-error private
          this._displayValue(),
        )}
        ?disabled=${this.disabled}
        type=${this.type === 'number' ? 'text' : this.type}
        inputmode=${ifDefined(this.type === 'number' ? 'decimal' : undefined)}
        ${injectAttributesOf(this, [
          'type',
          'disabled',
          ...(this['placeholder-mode'] === 'static-floating' ? [] : ['placeholder']),
        ])}
        ${ref(input => (this._input = input as HTMLInputElement | undefined))}
      />
    `;
  }
}
